(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shoppable-videos"] && !Shopify.designMode) return;
  try {
    
class KsShoppableVideos extends HTMLElement {
  constructor () {
    super()
    this.slider = null
    this.initializationAttempts = 0
    this.maxAttempts = 10
    this._initialized = false
    // do not touch DOM here; wait for connectedCallback
  }

  connectedCallback() {
    if (this._initialized) return
    this._initialized = true
    // Defer slightly to ensure child nodes are parsed by Shopify's renderer
    requestAnimationFrame(() => {
      this.loadSwiperAndInitialize()
      this.setupVideoEvents()
    })
  }

  // Clean up when removed (pause videos, destroy slider)
  disconnectedCallback() {
    try {
      this.querySelectorAll('video').forEach(v => v.pause())
      if (this.slider && typeof this.slider.destroy === 'function') {
        this.slider.destroy(true, true)
        this.slider = null
      }
    } catch (e) { /* silent */ }
  }

  async loadSwiperAndInitialize() {
    try {
      await this.ensureSwiperLoaded()
      await this.initializeSlider()
    } catch (error) {
      console.error('Failed to initialize Swiper slider:', error)
      // Fallback: show content without slider functionality
      this.showFallbackContent()
    }
  }

  ensureSwiperLoaded() {
    return new Promise((resolve, reject) => {
      if (window.Swiper) {
        resolve()
        return
      }

      let existingScript = document.querySelector('#swiper-script')

      if (!existingScript) {
        const script = document.createElement('script')
        script.setAttribute('src', 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.js')
        script.setAttribute('id', 'swiper-script')

        script.onload = () => {
          setTimeout(() => {
            if (window.Swiper) {
              resolve()
            } else {
              reject(new Error('Swiper not available after loading'))
            }
          }, 100)
        }

        script.onerror = () => {
          reject(new Error('Failed to load Swiper script'))
        }

        document.head.appendChild(script)
      } else {
        this.waitForSwiper(resolve, reject)
      }
    })
  }

  waitForSwiper(resolve, reject) {
    const checkSwiper = () => {
      this.initializationAttempts++

      if (window.Swiper) {
        resolve()
      } else if (this.initializationAttempts >= this.maxAttempts) {
        reject(new Error('Swiper loading timeout'))
      } else {
        setTimeout(checkSwiper, 200)
      }
    }

    checkSwiper()
  }

  async initializeSlider() {
    const swiperElement = this.querySelector('.swiper')
    if (!swiperElement) {
      throw new Error('Swiper element not found')
    }

    // ensure pagination and scrollbar elements exist before passing to Swiper
    const paginationEl = swiperElement.querySelector('.swiper-pagination')
    const scrollbarEl = swiperElement.querySelector('.swiper-scrollbar')
    const nextEl = swiperElement.querySelector('.swiper-button-next')
    const prevEl = swiperElement.querySelector('.swiper-button-prev')

    const options = this.splideOptions()

    // navigation as DOM elements (Swiper accepts elements)
    options.navigation = {
      enabled: this.dataset.sliderNav === 'true',
      nextEl: nextEl || null,
      prevEl: prevEl || null
    }

    // pagination
    if (this.dataset.sliderPagination === 'true') {
      options.pagination = {
        enabled: true,
        type: this.dataset.sliderPaginationType || 'bullets',
        el: paginationEl || undefined,
        dynamicBullets: true,
        dynamicMainBullets: 2,
        renderFraction: function (currentClass, totalClass) {
          return `<span class="${currentClass}"></span>/<span class="${totalClass}"></span>`
        }
      }
    } else {
      options.pagination = { enabled: false }
    }

    // scrollbar
    if (this.dataset.sliderScrollbar === 'true' && scrollbarEl) {
      options.scrollbar = { enabled: true, el: scrollbarEl, draggable: true }
    } else {
      options.scrollbar = { enabled: false }
    }

    // Initialize Swiper
    this.slider = new window.Swiper(swiperElement, options)

    // Setup event listeners
    this.slider.on('slideChange', () => {
      swiperElement.classList.add('swiper-is-changing')
      this.onSlideChange()
    })

    this.slider.on('slideChangeTransitionEnd', () => {
      swiperElement.classList.remove('swiper-is-changing')
    })

    // Mark as initialized
    swiperElement.classList.add('swiper-initialized')
  }

  showFallbackContent() {
    const swiperElement = this.querySelector('.swiper')
    if (swiperElement) {
      swiperElement.style.opacity = '1'
      swiperElement.classList.add('swiper-fallback')

      const nav = this.querySelectorAll('.swiper-button-prev, .swiper-button-next, .swiper-pagination, .swiper-scrollbar')
      nav.forEach(el => el && (el.style.display = 'none'))
    }
  }

  setupVideoEvents() {
    // Button play events
    this.querySelectorAll('.custom-shoppable-videos-btn-play').forEach(btn => {
      btn.addEventListener('click', (ev) => {
        ev.preventDefault()
        const wrapper = btn.closest('.custom-shoppable-videos-video-wrapper')
        const video = wrapper ? wrapper.querySelector('video') : null
        if (video) this.onVideoPlay(video)
      })
    })

    // Clicking video toggles play/pause
    this.querySelectorAll('video').forEach(video => {
      video.addEventListener('click', () => {
        this.onVideoPlay(video)
      })
      // pause on ended
      video.addEventListener('ended', () => {
        const card = video.closest('.custom-shoppable-videos-card')
        if (card) card.setAttribute('data-is-playing', 'false')
      })
    })
  }

  splideOptions() {
    const partialSlidesMobile = this.dataset.partialSlidesMobile === 'true' ? 1.2 : 1

    return {
      rewind: true,
      speed: Number(this.dataset.sliderSpeed) || 300,
      breakpoints: {
        0: { slidesPerView: Number(this.dataset.breakpointXs) * partialSlidesMobile || 1 },
        576: { slidesPerView: Number(this.dataset.breakpointSm) || 1 },
        768: { slidesPerView: Number(this.dataset.breakpointMd) || 1 },
        992: { slidesPerView: Number(this.dataset.breakpointLg) || 1 },
        1200: { slidesPerView: Number(this.dataset.breakpointXl) || 1 },
        1400: { slidesPerView: Number(this.dataset.breakpointXxl) || 1 }
      },
      autoplay: this.dataset.sliderAutoplay && this.dataset.sliderAutoplay !== '0'
        ? { delay: Number(this.dataset.sliderAutoplay) * 1000 }
        : false,
      watchSlidesProgress: true,
      mousewheel: {
        enabled: true,
        forceToAxis: true
      }
    }
  }

  onSlideChange() {
    this.querySelectorAll('.custom-shoppable-videos-card').forEach(elem => {
      elem.setAttribute('data-is-playing', 'false')
      elem.querySelector('video')?.pause()
    })
  }

  onVideoPlay(video) {
    if (!video) return
    const card = video.closest('.custom-shoppable-videos-card')
    if (!card) return

    this.querySelectorAll('.custom-shoppable-videos-card').forEach(elem => {
      if (elem.dataset.index !== card.dataset.index) {
        elem.setAttribute('data-is-playing', 'false')
        elem.querySelector('video')?.pause()
      }
    })

    if (card.dataset.isPlaying === 'true') {
      card.setAttribute('data-is-playing', 'false')
      video.pause()
    } else {
      card.setAttribute('data-is-playing', 'true')
      // Ensure video isn't blocked by autoplay policies: try muted first
      try {
        video.muted = false
        video.play().catch(() => {
          // If unmuted play fails (autoplay policy), try play muted then unmute
          video.muted = true
          video.play().catch(() => {/* ignore */})
        })
      } catch (e) {
        console.warn('Video play error', e)
      }
    }
  }
}

customElements.define('custom-shoppable-videos', KsShoppableVideos)

  } catch(e) { console.error(e); }
})();
})();
